import { Role } from '@/api/types'

export default [
    {
        name: 'user',
        path: '/user',
        meta: { requiredRole: Role.EMPLOYEE, showSidebar: false, showScrollbar: false },
        component: () => import(/* webpackChunkName: "user" */ '../../views/User/UserAuthLayout.vue'),
        props: route => {
            return {
                redirect: route.query.redirect || '/',
            }
        },
        children: [
            {
                name: 'user_login',
                path: '/user/login',
                meta: { anonymous: true, showSidebar: false, showScrollbar: false },
                component: () => import(/* webpackChunkName: "user_login" */ '../../views/User/Login.vue'),
            },
            {
                name: 'user_logout',
                path: '/logout',
                meta: { anonymous: true, showSidebar: false, showScrollbar: false },
                component: () => import(/* webpackChunkName: "user_logout" */ '../../views/User/Logout.vue'),
            },
            {
                name: 'user_reset_password',
                path: '/user/reset',
                meta: { anonymous: true, showSidebar: false, showScrollbar: false },
                component: () => import(/* webpackChunkName: "user_reset_password" */ '../../views/User/ResetPassword.vue'),
            },
            {
                name: 'user_reset_password_success',
                path: '/user/reset-success',
                meta: { anonymous: true, showSidebar: false, showScrollbar: false },
                component: () => import(/* webpackChunkName: "user_reset_password_success" */ '../../views/User/ResetPasswordSuccess.vue'),
            },
            {
                name: 'user_perform_reset_password',
                path: '/user/reset/:request',
                props: true,
                meta: { anonymous: true, showSidebar: false, showScrollbar: false },
                component: () => import(/* webpackChunkName: "user_perform_reset_password" */ '../../views/User/PerformResetPassword.vue'),
            },
            {
                name: 'user_perform_reset_password_success',
                path: '/user/reset/:request/success',
                props: true,
                meta: { anonymous: true, showSidebar: false, showScrollbar: false },
                component: () => import(/* webpackChunkName: "user_perform_reset_password_success" */ '../../views/User/PerformResetPasswordSuccess.vue'),
            },
        ],
    },
]
